/**
 * @generated SignedSource<<e0d49c403d67e7adcf5e7811002581ac>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BuyerChatRespLazy_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"BuyerChatResp_viewer">;
  readonly " $fragmentType": "BuyerChatRespLazy_viewer";
};
export type BuyerChatRespLazy_viewer$key = {
  readonly " $data"?: BuyerChatRespLazy_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"BuyerChatRespLazy_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuyerChatRespLazy_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BuyerChatResp_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "519efc28a9dceb4e3f708a8fdc40fedb";

export default node;
